export default __webpack_public_path__ + "static/media/aviso.e288c02f.jpg";